export default {
  inserted(el, expression) {
    const childWidth = expression.value.childWidth;
    let lastScrollX = 0;
    let interval;
    if (!!window.cordova && window.device.platform === 'iOS') {
      function onscroll(e) { // eslint-disable-line no-inner-declarations
        if (!!interval) {
          clearInterval(interval);
        }
        lastScrollX = e.target.scrollLeft;
        interval = setInterval(function () {
          let scrollLeft = e.target.scrollLeft;
          if (scrollLeft === lastScrollX) {
            onEndScroll(el, childWidth);
            clearInterval(interval);
            el.removeEventListener('scroll', onscroll);
            interval = null;
          }
        }, 50);
      };
      el.ontouchend = () => {
        el.removeEventListener('scroll', onscroll);
        el.addEventListener('scroll', onscroll);
      };
      // el.ontouchstart = () => {
      // el.removeEventListener('scroll', onscroll);
      // }
      // el.onscroll = (e) => {
      //   if (!!interval) {
      //     clearInterval(interval);
      //   }
      //   lastScrollX = e.target.scrollLeft;
      //   console.log('SET lastScrollX', lastScrollX);
      //   console.log(Date.now());
      //   interval = setInterval(function () {
      //     let scrollLeft = e.target.scrollLeft;
      //     console.log(Date.now());
      //     console.log('scrollLeft', scrollLeft);
      //     console.log('lastScrollX', lastScrollX);
      //     if (scrollLeft === lastScrollX) {
      //       console.log('onEndScroll');
      //       onEndScroll(el, childWidth);
      //       clearInterval(interval);
      //       interval = null;
      //     }
      //   }, 100);
      // };
    } else {
      el.onscroll = (e) => {
        if (!!interval) {
          clearInterval(interval);
        }
        lastScrollX = e.target.scrollLeft;
        interval = setInterval(function () {
          let scrollLeft = e.target.scrollLeft;
          if (scrollLeft === lastScrollX) {
            console.log('onEndScroll');
            onEndScroll(el, childWidth);
            clearInterval(interval);
            interval = null;
          }
        }, 50);
      };
    }
  }
};
function onEndScroll(el, childWidth) {
  const curScrollX = el.scrollLeft;
  const diff = curScrollX % childWidth;
  const MAX_SCROLL = el.scrollWidth - el.offsetWidth;
  let end = 0;
  if (diff < (childWidth / 2)) {
    end = childWidth * Math.floor(curScrollX / childWidth);
  } else {
    end = childWidth * (Math.floor(curScrollX / childWidth) + 1);
  }
  if (end >= MAX_SCROLL) {
    end = childWidth * Math.floor(curScrollX / childWidth);
  }
  smoothScroll(el, end);
}

function smoothScroll(element, end) {
  const duration = 100;
  const clock = Date.now();
  let requestAnimationFrame = window.requestAnimationFrame || function (fn) {
    window.setTimeout(fn, 15);
  };
  // let offset = 0;
  // if (this.scrollOffSet) {
  //   if (isNaN(Number(this.scrollOffSet))) {
  //     throw 'scrollOffSet must have numerical values';
  //   }
  //   end -= this.scrollOffSet;
  // }
  const start = element.scrollLeft;
  let step = () => {
    let elapsed = Date.now() - clock;
    let position = _position(start, end, elapsed, duration);
    element.scrollLeft = position;
    if (elapsed > duration) {
    } else {
      requestAnimationFrame(step);
    }
  };
  step();
}

// ease in out function thanks to:
// http://blog.greweb.fr/2012/02/bezier-curve-based-easing-functions-from-concept-to-implementation/
function easeInOutCubic(t) {
  return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
}
/**
 * calculate the scroll position we should be in
 * given the start and end point of the scroll
 * the time elapsed from the beginning of the scroll
 * and the total duration of the scroll (default 500ms)
 */
function _position(start, end, elapsed, duration) {
  if (elapsed > duration) {
    return end;
  };
  return start + (end - start) * easeInOutCubic(elapsed / duration); // <-- you can change the easing funtion there
  // return start + (end - start) * (elapsed / duration); // <-- this would give a linear scroll
}

/*
private smoothScroll(element: HTMLElement, end: number): void {
  const duration = 500;
const clock: number = Date.now();
const requestAnimationFrame = window.requestAnimationFrame || function (fn) {
  window.setTimeout(fn, 15);
};
let offset:number = 0;
if (this.scrollOffSet) {
  if (isNaN(Number(this.scrollOffSet))) {
    throw 'scrollOffSet must have numerical values';
  }
  end -= this.scrollOffSet;
}
const start: number = element.scrollLeft;
let step = () => {
  let elapsed = Date.now() - clock;
  let position = this.position(start, end, elapsed, duration);
  element.scrollTop = position;
  if (elapsed > duration) {
  } else {
    requestAnimationFrame(step);
  }
};

}
*/
